import guest from "@/middleware/guest";

export default [
  {
      path: "",
      component: () => import("@/modules/layout/LandingLayout"),
      children: [
          {
              path: "/login",
              name: "genericLogin",
              meta: { middleware: [guest] },
              component: () => import("./GenericLogin"),
          },
      ]
  },
];





